import { PARTIES, PARTY_ORDER, type ContestedEntry } from '../lib/types';

interface Props {
  items: ContestedEntry[];
}

export function ContestedList({ items }: Props) {
  if (!items.length) {
    return (
      <section className="section">
        <h2>Hetaste striderna</h2>
        <p className="empty-state">Inga pågående strider just nu.</p>
      </section>
    );
  }

  return (
    <section className="section">
      <h2>Hetaste striderna</h2>
      {items.slice(0, 5).map(item => {
        const total = PARTY_ORDER.reduce(
          (s, p) => s + (item.followerCounts[p] ?? 0),
          0,
        ) || 1;
        return (
          <div key={item.districtId} style={{ padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
            <div style={{ marginBottom: 6 }}>
              <strong>{item.districtName}</strong>
            </div>
            <div style={{ display: 'flex', height: 8, borderRadius: 4, overflow: 'hidden' }}>
              {PARTY_ORDER.map(p => {
                const c = item.followerCounts[p] ?? 0;
                if (!c) return null;
                return (
                  <span
                    key={p}
                    style={{
                      width: `${(c / total) * 100}%`,
                      background: PARTIES[p].color,
                    }}
                    title={`${PARTIES[p].name}: ${c}`}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </section>
  );
}
